module.exports = __webpack_public_path__ + "assets/img/vtuber-high-active.ae21b29a.png";